import React from "react"
import closeIcon from "@/public/icons/close-dark-new.svg"

const PdpGroutChart = props => {
  const data = props.authorData
    ? props.authorData
    : props.componentProp
    ? JSON.parse(props.componentProp.staticText)
    : {}

  return (
    <div className="pdp-grout-chart-main">
      <div className="pdp-grout-chart">
        <div className="pdp-grout-chart__container">
          <div className="pdp-grout-chart__close-icon">
            <img
              src={closeIcon.src}
              alt="close"
              onClick={() => props.closePopup()}
            />
          </div>
          <div className="col-6 col-lg-6 col-md-6 col-sm-12 pdp-grout-chart__left-column">
            <div className="pdp-grout-chart__need">
              <div className="pdp-grout-chart__need-title">
                {data?.primarytitle ? 
                    <span dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(data?.primarytitle),
                    }}/> : ""}
              </div>
              <div className="pdp-grout-chart__need-details">
                {data?.primarydescription ? 
                      <span dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(data?.primarydescription),
                      }}/> : ""}
              </div>
              <div className="pdp-grout-chart__instruction-title">
                {data?.secondarytitle ? 
                      <span dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(data?.secondarytitle),
                      }}/> : ""}
              </div>
              <div className="pdp-grout-chart__instruction-details">
                {data?.secondarydescription ? 
                      <span dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(data?.secondarydescription),
                      }}/> : ""}
              </div>
            </div>
          </div>
          <div className="col-6 col-lg-6 col-md-6 col-sm-12 pdp-grout-chart__right-column">
            <div className="pdp-grout-chart__table">
              <div className="pdp-grout-chart__coverage-title">
                {data?.primarytitletable ? 
                      <span dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(data?.primarytitletable),
                      }}/> : ""}
              </div>

              <div className="pdp-grout-chart__coverage-desc">
                {data?.primarydescriptiontable ? 
                      <span dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(data?.primarydescriptiontable),
                      }}/> : ""}
              </div>
              <div className="pdp-grout-chart_table-data">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th className="pdp-grout-chart__table-tile">
                        {data.tablecontent1 ? data.tablecontent1 : ""}
                      </th>
                      <th className="pdp-grout-chart__table-width" colSpan="6">
                        {data.tablecontent2 ? data.tablecontent2 : ""}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.globalItems &&
                      data.globalItems.length > 0 &&
                      data.globalItems.map(e => Object.values(e))
                        .slice(0)
                        .map((e, key) => (
                          <tr key={key}>
                            {e.map((b, key) => (
                              <td key={key}>{b}</td>
                            ))}
                          </tr>
                        ))}
                  </tbody>
                </table>
              </div>
              <div className="pdp-grout-chart__coverage-warning">
                {data?.copyrighttext ? 
                      <span dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(data?.copyrighttext),
                      }}/> : ""}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PdpGroutChart
